import { useState } from 'react';
import Icon from '../AppIcon';

const FloatingActionButton = ({ onCreateTask, isModalOpen }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = () => {
    setIsPressed(true);
    setTimeout(() => setIsPressed(false), 150);
    onCreateTask();
  };

  return (
    <div className={`fab-container ${isModalOpen ? 'fab-hidden' : ''}`}>
      <button
        onClick={handleClick}
        className="fab-button"
        aria-label="Create new task"
        title="Create new task"
        style={{
          transform: isPressed ? 'scale(0.97)' : undefined,
        }}
      >
        <Icon name="Plus" size={24} color="currentColor" />
      </button>
    </div>
  );
};

export default FloatingActionButton;